import React, { Fragment, useEffect, useState } from 'react';
import Header from '../../components/Header';
import Page, { usePage } from '../../components/Page';
import { api } from '../../api';
import { useMatch, useNavigate } from 'react-router-dom';
import { useAuth } from '../../units/auth/AuthProvider';
import packageJson from '../../../package.json';
import { Button, Grid, Tab, Tabs, TextField } from '@mui/material';
import { useStyles } from '../../hooks/useStyles';
import { useGlobal } from '../../units/global/GlobalProvider';

export default function LoginPage() {
    const page = usePage();
    const classes = useStyles();
    const auth = useAuth();
    const { pageConfigs, setPageConfigs, reloadPageConfigs } = useGlobal();
    const [inputAccount, setInputAccount] = useState('');
    const [inputPassword, setInputPassword] = useState('');
    const [accessToken, setAccessToken] = useState<string | null>(null);
    const [idToken, setIdtoken] = useState<string | null>(null);
    const navigate = useNavigate();
    const atRoot = useMatch('/');
    const atLogin = useMatch('/login');
    const [tabIndex, setTabIndex] = useState<'login' | 'register'>('login');

    useEffect(() => {
        const queryString = window.location.search;
        const params = new URLSearchParams(queryString);
        const code = params.get('code');
        const clientId = process.env.REACT_APP_LINE_CLIENT_ID;
        const clientSecret = process.env.REACT_APP_LINE_CLIENT_SECRET;
        const redirectUri = process.env.REACT_APP_LINE_REDIRECT_URI;
        switch (true) {
            case params.size == 0:
                break;
            case typeof code == 'string' &&
                typeof clientId == 'string' &&
                typeof clientSecret == 'string' &&
                typeof redirectUri == 'string':
                page.setIsLoading(true);
                const urlencoded = new URLSearchParams();
                urlencoded.append('grant_type', 'authorization_code');
                urlencoded.append('code', code!);
                urlencoded.append('redirect_uri', redirectUri!);
                urlencoded.append('client_id', clientId!);
                urlencoded.append('client_secret', clientSecret!);

                fetch(`https://api.line.me/oauth2/v2.1/token`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: urlencoded,
                    redirect: 'follow',
                })
                    .then(async (ret) => {
                        if (ret.status == 200) {
                            const data: {
                                access_token: string;
                                expires_in: number;
                                id_token: string;
                                refresh_token: string;
                                scope: string;
                                token_type: string;
                            } = await ret.json();
                            setAccessToken(data.access_token);
                            setIdtoken(data.id_token);
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                    .finally(() => {
                        page.setIsLoading(false);
                    });
                break;
            default:
                break;
        }
    }, []);

    useEffect(() => {
        auth.isAuth &&
            reloadPageConfigs().then(() => {
                const cleanPath = window.location.pathname;
                window.history.replaceState({}, document.title, cleanPath);
                if (atRoot || atLogin) navigate('/home');
            });
    }, [auth.isAuth]);

    useEffect(() => {
        (async () => {
            try {
                if ((accessToken || '').length > 0 && (idToken || '').length > 0) {
                    await api.auth
                        .lineLogin({ access_token: accessToken, id_token: idToken })
                        .then((ret) => {
                            if (ret.access_token) {
                                auth.signIn(ret?.access_token || '');
                            } else {
                                auth.signOut();
                                page.alert.show({ type: 'error', title: '錯誤', message: ret.message });
                            }
                        })
                        .catch((error) => {
                            auth.signOut();
                            page.alert.show({ type: 'error', title: '錯誤', message: error.message });
                        });
                }
            } catch (error) {
                console.error(error);
            }
        })();
    }, [accessToken, idToken]);

    const onLogin = async () => {
        page.setIsLoading(true);
        await api.auth
            .login({ account: inputAccount, password: inputPassword })
            .then((ret) => {
                if (ret.access_token) {
                    auth.signIn(ret?.access_token || '');
                } else {
                    page.alert.show({ type: 'error', title: '錯誤', message: ret.message });
                }
            })
            .catch((error) => page.alert.show({ type: 'error', title: '錯誤', message: error.message }));
        page.setIsLoading(false);
    };

    const onLineLogin = () => {
        const clientId = process.env.REACT_APP_LINE_CLIENT_ID;
        if (!clientId) page.alert.show({ type: 'error', title: '錯誤', message: 'Line Client ID is null' });
        const clientSecret = process.env.REACT_APP_LINE_CLIENT_SECRET;
        if (!clientSecret) page.alert.show({ type: 'error', title: '錯誤', message: 'Line Client Secret is null' });
        const redirectUri = process.env.REACT_APP_LINE_REDIRECT_URI;
        if (!redirectUri) page.alert.show({ type: 'error', title: '錯誤', message: 'Line redirect uri is null' });
        window.location.href =
            `https://access.line.me/oauth2/v2.1/authorize?` +
            [
                `response_type=code`,
                `client_id=${clientId}`,
                `redirect_uri=${redirectUri}`,
                `state=${Math.floor(Math.random() * 1000000)}`,
                `scope=profile%20openid%20email`,
            ].join('&');
    };

    return (
        <Page {...page} title='登入頁面'>
            <Grid container flexDirection={'column'} height={'100%'}>
                <Grid
                    container
                    item
                    flex={1}
                    flexDirection={'column'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    sx={{ padding: '4px 16px' }}
                >
                    <Header />
                    <Grid container item height={20} />
                    <Grid
                        container
                        item
                        justifyContent={'center'}
                        alignItems={'center'}
                        padding={2}
                        gap={1}
                        maxWidth={500}
                        minWidth={220}
                        // maxHeight={360}
                        // minHeight={360}
                        sx={{ border: '1px solid rgba(63, 81, 181, .6)', borderRadius: 2, backgroundColor: 'white' }}
                    >
                        {/* <Tabs value={tabIndex} onChange={(e, v) => setTabIndex(v)}>
                            <Tab value={'login'} label={'登入'} />
                            <Tab value={'register'} label={'註冊'} />
                        </Tabs> */}
                        {tabIndex == 'login' ? (
                            <Fragment>
                                <Grid container item justifyContent={'center'} alignItems={'center'} xs={12}>
                                    <TextField
                                        variant='outlined'
                                        label='帳號'
                                        fullWidth
                                        sx={{ backgroundColor: 'white', margin: 1 }}
                                        value={inputAccount}
                                        onChange={(e) => setInputAccount(e.target.value)}
                                    />
                                </Grid>
                                <Grid container item justifyContent={'center'} alignItems={'center'} xs={12}>
                                    <TextField
                                        variant='outlined'
                                        label='密碼'
                                        type='password'
                                        fullWidth
                                        sx={{ backgroundColor: 'white', margin: 1 }}
                                        value={inputPassword}
                                        onChange={(e) => setInputPassword(e.target.value)}
                                        onKeyDown={(e) => e.key === 'Enter' && onLogin()}
                                    />
                                </Grid>
                                <Grid container item justifyContent={'center'} alignItems={'center'} xs={12}>
                                    <Button
                                        disabled={![inputAccount.length > 0, inputPassword.length > 0].every((v) => v)}
                                        className={classes.buttonCyan}
                                        sx={{ margin: 1 }}
                                        variant='contained'
                                        size='large'
                                        fullWidth
                                        onClick={onLogin}
                                    >
                                        {'登入'}
                                    </Button>
                                </Grid>
                                <Grid container item justifyContent={'center'} alignItems={'center'} xs={12}>
                                    <Button
                                        fullWidth
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            margin: 1,
                                            color: '#FFFFFF',
                                            backgroundColor: '#06C755',
                                            borderRadius: 1,
                                            height: '40px',
                                            '&:hover': {
                                                backgroundColor: '#05B34C',
                                            },
                                            '&:active': {
                                                backgroundColor: '#048B3B',
                                            },
                                            '&:disabled': {
                                                backgroundColor: '#06C755',
                                            },
                                        }}
                                        onClick={onLineLogin}
                                    >
                                        <Grid container item width={'40px'} sx={{ borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>
                                            <img
                                                src={`${require('../../img/btn_transparent.png')}`}
                                                className='line-icon'
                                                style={{ height: '32px' }}
                                            />
                                        </Grid>
                                        <Grid container item justifyContent={'center'} flex={1} sx={{ textTransform: 'none' }}>
                                            {'Log in With Line'}
                                        </Grid>
                                    </Button>
                                </Grid>
                            </Fragment>
                        ) : tabIndex == 'register' ? (
                            <Fragment></Fragment>
                        ) : (
                            <></>
                        )}
                    </Grid>
                    <Grid container item flex={1} />
                    <Grid container item minHeight={40} flexDirection={'row'} justifyContent={'flex-end'} alignItems={'end'}>
                        {packageJson.version}
                    </Grid>
                </Grid>
            </Grid>
        </Page>
    );
}
